import { NotificationInbox } from "@minga/protocol"
import { queryOptions } from "@tanstack/react-query"
import { Schema } from "effect"
import { apiJson } from "./api"

/** The bell's rows, a page of 50 from `offset`. Asked for only while the bell is open. */
export const notificationsQuery = (workspaceId: string, offset = 0) =>
  queryOptions({
    queryKey: ["me", "notifications", workspaceId, offset],
    queryFn: () =>
      apiJson(
        // onboarding week A8: news only; cards still waiting on you are Needs you's (one count each, never overlapping)
        `/api/me/notifications?workspace=${encodeURIComponent(workspaceId)}&offset=${offset}&news=1`,
        NotificationInbox,
      ),
    staleTime: 15_000,
    refetchInterval: 30_000,
  })

/**
 * Performance follow-up (0151 proposal 9): the bell's unread count on every page, without its rows (`count=1`: about
 * 40 KB less per page load). Under the same key prefix as the rows, so marking read refreshes both. An older Worker
 * ignores `count` and answers the rows too, which decode the same.
 */
export const notificationsCountQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: ["me", "notifications", workspaceId, "count"],
    queryFn: () =>
      apiJson(
        `/api/me/notifications?workspace=${encodeURIComponent(workspaceId)}&news=1&count=1`,
        NotificationInbox,
      ),
    select: (inbox) => inbox.unread,
    staleTime: 15_000,
    refetchInterval: 30_000,
  })

export const markNotificationsRead = (ids: ReadonlyArray<string>) =>
  apiJson("/api/me/notifications/seen", Schema.Struct({ ok: Schema.Boolean }), {
    method: "POST",
    body: { ids },
  })
